import { connect } from "react-redux";
import get from "lodash/get";

import {
  getReprocessUnits as onGetReprocessUnits,
  createReprocessUnit as onCreateReprocessUnit,
  deleteReprocessUnit as onDeleteReprocessUnit,
  getReprocessTypes as onGetReprocessTypes,
} from "../../actions/reprocessUnitsActions";

const mapStateToProps = (state) => ({
  reprocessUnitsDataState: state.reprocessUnits.reprocessUnitsDataState,
  createReprocessUnitsDataState: state.reprocessUnits.createReprocessUnitsDataState,
  deleteReprocessUnitsDataState: state.reprocessUnits.deleteReprocessUnitsDataState,
  reprocessTypesDataState: state.reprocessUnits.reprocessTypesDataState,
  lastSchedulerTime: get(state, ["reprocessUnits", "lastSchedulerTime"], null),
  reprocessUnits: get(state, ["reprocessUnits", "reprocessUnits"], []),
  reprocessTypes: get(state, ["reprocessUnits", "reprocessTypes"], []),
  errors: get(state, ["reprocessUnits", "errors"], []),
});

const mapDispatchToProps = { onGetReprocessUnits, onCreateReprocessUnit, onDeleteReprocessUnit, onGetReprocessTypes };

const withReprocessUnits = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withReprocessUnits };
